// extracted by mini-css-extract-plugin
export default {"hideMapButton":"S1c8gT"};